export default "__VITE_ASSET__cyih6Y$L__"